import React from 'react';
import StickyHeader from '../components/stickyHeader';
import { MdDoubleArrow } from 'react-icons/md';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function Blog() {
    return (
        <div>
            {/* <StickyHeader /> */}

            <div className="blog-banner-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <h2>Blogs</h2>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><MdDoubleArrow /></li>
                                <li><Link to="/blogs">Blogs</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="inner-blog-main-sec">
                    <div className="container">
                        
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <h4>Coming Soon</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />


        </div>
    )
}
